
<Modal mayCancel="true" v-on:done="onCancel" v-on:cancel="onCancel">
  <h2>{{ title }}</h2>
  <p>{{ prompt }}</p>
  <div class="ButtonRow_Right">
    <button class="WBMBigButton" v-on:click="onCancel">Cancel</button>
    <button class="WBMBigButton m-primary" v-on:click="onOK">OK</button>
  </div>
</Modal>
